import * as React from 'react';
import { PaymentReturnPageContainer } from './containers/payment-return-page.container';

export const PaymentReturnPage: React.FC = () => {
    return (
        <PaymentReturnPageContainer />
    );
};
